/*************************************************************************
 *
 * KLEARNOW CONFIDENTIAL
 * __________________
 *
 *  Copyright (c) 2018 - 2020 KLEARNOW Corporation.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of KLEARNOW Corporation and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to KLEARNOW Corporation
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from KLEARNOW Corporation.
 */

import axios from 'axios'
import { getCookie } from '../util'

axios.defaults.baseURL = window._env_.REACT_APP_BROKER_API_URL
axios.defaults.headers.common['Accept'] = 'application/json'
axios.defaults.headers.common['Content-Type'] = 'application/json'
const isLoginPage = document.getElementById('txtInputName');
if(!isLoginPage){
  axios.defaults.headers.common['kxToken'] = getCookie('kxEntrySummaryToken') || getCookie(window.GLOBAL_MAIN_TOKEN_KXBROKERTOKEN)
}
axios.defaults.method = 'post'

const custom = (config = {}) => {
  let queryParamsString = "&"
  Object.keys(config.queryParams || {}).map(param => {
    queryParamsString = queryParamsString + param + "=" + config.queryParams[param] + "&"
  })
  config.url=config.url || axios.defaults.baseURL+ "?axd="+config.data.eventType + queryParamsString;
  return axios(config)
}

const post = data => {
  let config = {}
  config.data = data
  config.url=config.url || axios.defaults.baseURL+ "?axd="+config.data.eventType;
  return axios(config)
}

const get = (url = '', data = '', config = {}) => {
  config.params = data
  config.method = 'get'
  return axios.get(url, config)
}

const put = (url = '', data = '', config = {}) => {
  return axios.put(url, data, config)
}

const del = (url = '', config = {}) => {
  return axios.delete(url, config)
}

const HttpClient = {
  custom,
  post,
  get,
  put,
  delete: del
}

export { HttpClient }
